import { render, staticRenderFns } from "./TrainingManagement.vue?vue&type=template&id=bf18b924&scoped=true"
import script from "./TrainingManagement.vue?vue&type=script&lang=js"
export * from "./TrainingManagement.vue?vue&type=script&lang=js"
import style0 from "./TrainingManagement.vue?vue&type=style&index=0&id=bf18b924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf18b924",
  null
  
)

export default component.exports